import { render, staticRenderFns } from "./SuggestedOrderStatus.vue?vue&type=template&id=34451f6d"
import script from "./SuggestedOrderStatus.vue?vue&type=script&lang=js"
export * from "./SuggestedOrderStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3338226073/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34451f6d')) {
      api.createRecord('34451f6d', component.options)
    } else {
      api.reload('34451f6d', component.options)
    }
    module.hot.accept("./SuggestedOrderStatus.vue?vue&type=template&id=34451f6d", function () {
      api.rerender('34451f6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SuggestedOrderStatus.vue"
export default component.exports